import actions from 'Actions';
import Empty from 'constants/empty';
import Cookies from 'utils/Cookies';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';

// Recently-viewed category cookie. Per the architect decision, the backend emits a
// single, shared `rvcat` cookie (no per-user `rvcat_{userId}` suffix). The value is an
// `&`-delimited list of category IDs (most-recent-first, deduplicated).
const RV_CATEGORY_COOKIE = 'rvcat';

function updateRvData(rvData) {
    return dispatch => dispatch(actions.addRecentlyViewedData(rvData || Empty.Array));
}

function readRvCategoryCookie() {
    if (typeof document === 'undefined') {
        return [];
    }

    const cookieValue = Cookies.read(RV_CATEGORY_COOKIE);

    if (!cookieValue) {
        return [];
    }

    return cookieValue.split('&').filter(Boolean);
}

function updateRvCategoryData() {
    return dispatch => {
        const parsed = readRvCategoryCookie();
        const cookieCategoryIds = Array.isArray(parsed) ? parsed : [];

        Storage.local.setItem(LOCAL_STORAGE.RV_CATEGORY_DATA, cookieCategoryIds);
        dispatch(actions.addRvCategoryData(cookieCategoryIds));
    };
}

export default { updateRvData, readRvCategoryCookie, updateRvCategoryData };
